import { addDays, isWeekend } from "date-fns";

/**
 * Returns the 7 dates of the week beginning at `weekStart`. With
 * `hideWeekends` only the 5 weekdays are returned, regardless of which day
 * the week starts on (Sunday/Monday/Saturday are all supported).
 */
export const getWeekDates = (weekStart: Date, hideWeekends = false): Date[] => {
  const days: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const day = addDays(weekStart, i);
    if (hideWeekends && isWeekend(day)) {
      continue;
    }
    days.push(day);
  }
  return days;
};
